import { createFileRoute } from '@tanstack/react-router';
import type { DiscoveryStatus } from '@/pages/Integrations/discovery/discovery-types';

const VALID_STATUSES: readonly DiscoveryStatus[] = [
  'AUTO_MATCHED',
  'SUGGESTED',
  'UNMATCHED',
  'CONFIRMED',
  'SKIPPED',
];

export interface DiscoverySearch {
  /** Active status filter, mirrored to the URL so it's shareable + survives
   *  refresh. Absent / empty = all. The "pending review" banner seeds this with
   *  the awaiting-review statuses. */
  status?: DiscoveryStatus[];
  /** Free-text org search, mirrored to the URL. The sync dialog's "Review N
   *  organisation" action seeds this with the just-discovered org's name so the
   *  table filters straight to it. Absent / empty = no text filter. */
  q?: string;
}

export const Route = createFileRoute(
  '/integrations/providers/$providerId/discovery',
)({
  validateSearch: (search: Record<string, unknown>): DiscoverySearch => {
    const raw = search.status;
    const arr = Array.isArray(raw)
      ? raw
      : typeof raw === 'string'
        ? raw.split(',')
        : [];
    const status = arr.filter(
      (s): s is DiscoveryStatus =>
        typeof s === 'string' && VALID_STATUSES.includes(s as DiscoveryStatus),
    );
    const q = typeof search.q === 'string' && search.q.trim() ? search.q.trim() : undefined;
    return {
      ...(status.length ? { status } : {}),
      ...(q ? { q } : {}),
    };
  },
});
